import { createAction } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const AppActionTypes = keyMirror({
  APPLICATION_START: null,
  TOGGLE_EDIT_NAME: null,
  TOGGLE_EDIT_PHONE_NUMBER: null,
  TOGGLE_ADD_EMAIL_ADDRESS_MODAL: null,
  TOGGLE_EDIT_EMAIL_ADDRESS_MODAL: null,
  TOGGLE_CHANGE_PASSWORD_MODAL: null,
  TOGGLE_FORGOT_PASSWORD_MODAL: null,
  TOGGLE_EDIT_SIGNATURE_MODAL: null,
  TOGGLE_ADD_EMAIL_MODAL: null,
  TOGGLE_CHANGE_PRIMARY_MODAL: null,
  TOGGLE_LOG_OUT_ALL_SESSIONS_MODAL: null,
  TOGGLE_DELETE_TRUSTED_NUMBER_MODAL: null,
  TOGGLE_UPDATE_TRUSTED_NUMBER_MODAL: null
});
export const start = () => createAction(AppActionTypes.APPLICATION_START);
export const toggleEditNamePopover = () => createAction(AppActionTypes.TOGGLE_EDIT_NAME);
export const toggleAddEmailAddressModalOpen = () => createAction(AppActionTypes.TOGGLE_ADD_EMAIL_ADDRESS_MODAL);
export const toggleEditEmailAddressModalOpen = () => createAction(AppActionTypes.TOGGLE_EDIT_EMAIL_ADDRESS_MODAL);
export const toggleChangePasswordModalOpen = () => createAction(AppActionTypes.TOGGLE_CHANGE_PASSWORD_MODAL);
export const toggleForgotPasswordModalOpen = () => createAction(AppActionTypes.TOGGLE_FORGOT_PASSWORD_MODAL);
export const toggleEditSignatureModalOpen = () => createAction(AppActionTypes.TOGGLE_EDIT_SIGNATURE_MODAL);
export const toggleAddEmailModal = () => createAction(AppActionTypes.TOGGLE_ADD_EMAIL_MODAL);
export const toggleChangePrimaryModal = () => createAction(AppActionTypes.TOGGLE_CHANGE_PRIMARY_MODAL);
export const toggleLogOutAllSessionsModalOpen = () => createAction(AppActionTypes.TOGGLE_LOG_OUT_ALL_SESSIONS_MODAL);
export const toggleDeleteTrustedNumberModal = () => {
  return createAction(AppActionTypes.TOGGLE_DELETE_TRUSTED_NUMBER_MODAL);
};
export const toggleUpdateTrustedNumberModal = () => {
  return createAction(AppActionTypes.TOGGLE_UPDATE_TRUSTED_NUMBER_MODAL);
};